/* ============================================================================
   MAHA card-product-v2.js
   Conecta las 5 funciones de venta de la tarjeta v2 con datos REALES:
     1. Formato de venta  -> metafields por variante (JSON server-rendered)
     2. Stock             -> inventario nativo por variante
     3. Total por cantidad-> precio real x cantidad, recalculado en vivo
     4. Precio por mayoreo-> tramos REALES del endpoint HulkApps
                             (volumediscount.hulkapps.com — mismo endpoint y token
                              que ya usa assets/wishlist.js en esta tienda)
     5. Cantidad + ATC    -> quantity-input del tema (theme.js) + form 'product'
   No inventa tramos ni precios: si HulkApps no devuelve oferta, el bloque de
   mayoreo permanece oculto. El descuento en el carrito lo aplica HulkApps.
   Rendimiento: fetch perezoso (IntersectionObserver), cache en sessionStorage
   (30 min) y máximo 4 peticiones concurrentes.
   ============================================================================ */
(function () {
  'use strict';
  if (window.__mahaCardV2Init) return;
  window.__mahaCardV2Init = true;

  var HULK_URL = 'https://volumediscount.hulkapps.com/v1/products';
  var SHOP_DOMAIN = 'rafael-jjuan.myshopify.com';
  /* Token público ya embebido por la app en el frontend del tema (assets/wishlist.js:985) */
  var HULK_AUTH =
    'eyJhbGciOiJIUzI1NiJ9.eyJpc3MiOiJpc3N1ZXJfbmFtZSIsImF1ZCI6ImNsaWVudCIsInRva2VuX25hbWUiOiJnZXRfcmVzcG9uc2UiLCJzaG9wX2lkIjo2ODI5OCwiY3JlYXRlX3RpbWUiOiIyMDI1LTAxLTI4IDEwOjIyOjAyICswMDAwIn0.3DiZKuoe26tjfnVbYIpF3YTtPo9ibVP_1xKRrVORaZw';
  var CACHE_TTL = 30 * 60 * 1000;
  var MAX_CONCURRENT = 4;

  /* ---------------- money ---------------- */
  function formatMoney(cents, format) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    var value = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = format || '${{amount}}';
    function numberWithDelimiters(number, precision, thousands, decimal) {
      precision = precision == null ? 2 : precision;
      thousands = thousands || ',';
      decimal = decimal || '.';
      if (isNaN(number) || number == null) return 0;
      number = (number / 100.0).toFixed(precision);
      var parts = number.split('.');
      var dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var centsAmount = parts[1] ? decimal + parts[1] : '';
      return dollarsAmount + centsAmount;
    }
    switch (formatString.match(placeholderRegex)[1]) {
      case 'amount': value = numberWithDelimiters(cents, 2); break;
      case 'amount_no_decimals': value = numberWithDelimiters(cents, 0); break;
      case 'amount_with_comma_separator': value = numberWithDelimiters(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = numberWithDelimiters(cents, 0, '.', ','); break;
      default: value = numberWithDelimiters(cents, 2);
    }
    return formatString.replace(placeholderRegex, value);
  }

  /* ---------------- HulkApps tiers (fuente real de mayoreo) ---------------- */
  var inFlight = 0;
  var fetchQueue = [];
  var memCache = {};

  function cacheKey(pid, vid) { return 'mahaVD:' + pid + ':' + vid; }

  function readSession(key) {
    try {
      var raw = sessionStorage.getItem(key);
      if (!raw) return null;
      var obj = JSON.parse(raw);
      if (!obj || Date.now() - obj.t > CACHE_TTL) return null;
      return obj.tiers;
    } catch (e) { return null; }
  }

  function writeSession(key, tiers) {
    try { sessionStorage.setItem(key, JSON.stringify({ t: Date.now(), tiers: tiers })); } catch (e) {}
  }

  function parseOfferLevels(data) {
    /* Respuesta real: eligible_offer.offer_levels = '[["13","10","% Off","","0"],["25","15","% Off","","0"]]' */
    var tiers = [];
    try {
      if (!data || !data.eligible_offer || !data.eligible_offer.offer_levels) return tiers;
      if (data.eligible_offer.is_active === false) return tiers;
      var levels = JSON.parse(data.eligible_offer.offer_levels);
      for (var i = 0; i < levels.length; i++) {
        var row = levels[i];
        var type = (row[2] || '').toString();
        /* Solo tramos de porcentaje: cualquier otro tipo no se muestra (no inventar precios). */
        if (type.indexOf('%') === -1) continue;
        var min = parseInt(row[0], 10);
        var pct = parseFloat(row[1]);
        if (!isFinite(min) || !isFinite(pct) || min <= 0 || pct <= 0) continue;
        tiers.push({ min: min, percent: pct });
      }
      tiers.sort(function (a, b) { return a.min - b.min; });
    } catch (e) { /* respuesta inesperada -> sin tramos */ }
    return tiers;
  }

  function fetchTiers(pid, vid) {
    var key = cacheKey(pid, vid);
    if (memCache[key]) return memCache[key];
    var cached = readSession(key);
    if (cached) {
      memCache[key] = Promise.resolve(cached);
      return memCache[key];
    }
    memCache[key] = new Promise(function (resolve) {
      fetchQueue.push(function () {
        var ctrl = 'AbortController' in window ? new AbortController() : null;
        var timer = ctrl ? setTimeout(function () { ctrl.abort(); }, 8000) : null;
        fetch(HULK_URL + '?product_id=' + pid + '&shop_domain=' + SHOP_DOMAIN + '&product_variants=' + vid, {
          method: 'GET',
          headers: { Authorization: HULK_AUTH, 'Content-Type': 'application/json' },
          signal: ctrl ? ctrl.signal : undefined
        })
          .then(function (r) { return r.ok ? r.json() : null; })
          .then(function (data) {
            var tiers = parseOfferLevels(data);
            writeSession(key, tiers);
            resolve(tiers);
          })
          .catch(function () { resolve([]); })
          .finally(function () {
            if (timer) clearTimeout(timer);
            inFlight--;
            pump();
          });
      });
      pump();
    });
    return memCache[key];
  }

  function pump() {
    while (inFlight < MAX_CONCURRENT && fetchQueue.length) {
      inFlight++;
      fetchQueue.shift()();
    }
  }

  /* ---------------- estado por tarjeta ---------------- */
  function getState(card) { return card.__v2State; }

  function initCard(card) {
    if (card.dataset.v2Ready) return;
    card.dataset.v2Ready = '1';

    var variants = [];
    var jsonEl = card.querySelector('[data-variants-json]');
    if (jsonEl) {
      try { variants = JSON.parse(jsonEl.textContent); } catch (e) { variants = []; }
    }
    var currentId = parseInt(card.dataset.variantId, 10);
    var current = null;
    for (var i = 0; i < variants.length; i++) {
      if (variants[i].id === currentId) { current = variants[i]; break; }
    }
    var moneyFormat = card.dataset.currencyEnabled === 'true'
      ? (card.dataset.moneyFormatCurrency || card.dataset.moneyFormat)
      : card.dataset.moneyFormat;

    card.__v2State = {
      variants: variants,
      variant: current,
      tiers: [],
      moneyFormat: moneyFormat || '${{amount}}',
      basePriceText: null
    };

    var vol = card.querySelector('[data-vol]');
    if (vol) {
      vol.addEventListener('toggle', function () {
        if (!vol.open) return;
        loadTiers(card);
        /* R3 - los observers cubren la llegada tardia de filas; scheduleTightMeasure
           hace el primer intento tras layout + paint de la apertura. */
        var box = card.querySelector('[data-vol-tiers]');
        observeTight(box);
        scheduleTightMeasure(box);
      });
    }

    /* CARRUSEL-MINIATURAS: estado inicial de las flechas de esta tarjeta. */
    var strip0 = card.querySelector('.product-card-v2__thumbnails');
    if (strip0) updateArrows(strip0);

    refresh(card);
  }

  function qtyInput(card) { return card.querySelector('.product-card-v2__qty .quantity__input'); }
  function currentQty(card) {
    var input = qtyInput(card);
    var q = input ? parseInt(input.value, 10) : 1;
    return isFinite(q) && q > 0 ? q : 1;
  }

  function activeTier(tiers, qty) {
    var t = null;
    for (var i = 0; i < tiers.length; i++) { if (qty >= tiers[i].min) t = tiers[i]; }
    return t;
  }

  function tierUnitCents(baseCents, tier) {
    return Math.round(baseCents * (100 - tier.percent)) / 100;
  }

  function visiblePriceItem(card) {
    var root = card.querySelector('.product-card-v2__price-block .f-price');
    if (!root) return null;
    if (root.classList.contains('f-price--on-sale')) {
      return root.querySelector('.f-price__sale .f-price-item--sale');
    }
    return root.querySelector('.f-price__regular .f-price-item--regular');
  }

  /* ---------------- render: precio, tramos, total ---------------- */
  function refresh(card) {
    var st = getState(card);
    if (!st || !st.variant) return;
    var v = st.variant;
    var qty = currentQty(card);
    var tier = activeTier(st.tiers, qty);
    var unitCents = tier ? tierUnitCents(v.price, tier) : v.price;

    /* precio por pieza — innerHTML: el money_format de la tienda incluye markup (app de moneda) */
    var priceItem = visiblePriceItem(card);
    if (priceItem) {
      if (st.basePriceText === null) st.basePriceText = priceItem.innerHTML;
      priceItem.innerHTML = ' ' + formatMoney(unitCents, st.moneyFormat) + ' ';
      priceItem.classList.toggle('is-tier-price', !!tier);
    }
    var from = card.querySelector('[data-price-from]');
    if (from) {
      /* Mostrar "Mayoreo" si: (1) hay tier activo OR (2) hay descuento real (compare_at_price > price) */
      var priceBlock = card.querySelector('.product-card-v2__price-block .f-price');
      var hasDiscount = priceBlock && priceBlock.classList.contains('f-price--on-sale');
      var showLabel = st.tiers.length > 0 || hasDiscount;
      if (showLabel) {
        from.hidden = false;
        from.textContent = (tier || hasDiscount) ? 'Mayoreo' : 'Desde';
      } else {
        from.hidden = true;
      }
    }
    var was = card.querySelector('[data-price-was]');
    if (was) {
      if (tier) {
        was.innerHTML = formatMoney(v.price, st.moneyFormat);
        was.hidden = false;
      } else {
        was.hidden = true;
      }
    }

    /* total por cantidad */
    var subQty = card.querySelector('[data-subtotal-qty]');
    var subUnit = card.querySelector('[data-subtotal-unit]');
    var subVal = card.querySelector('[data-subtotal]');
    if (subQty) subQty.textContent = qty;
    /* TOTAL-UNA-SOLA-ETIQUETA (2026-08-18): [data-subtotal-unit] ya no se VE en
       ningun ancho -- vive dentro del .visually-hidden de la etiqueta del total.
       La abreviatura "pz"/"pzas" existia solo para ahorrar ancho en pantalla, y
       leida en voz alta es peor que la palabra completa, asi que se emite
       siempre entera. El resto del calculo no se toca. */
    if (subUnit) subUnit.textContent = qty === 1 ? 'pieza' : 'piezas';
    if (subVal) subVal.innerHTML = formatMoney(unitCents * qty, st.moneyFormat);

    /* tramo activo en el desplegable */
    var rows = card.querySelectorAll('[data-vol-tiers] .product-card-v2__vol-tier');
    for (var i = 0; i < rows.length; i++) {
      var min = parseInt(rows[i].getAttribute('data-min'), 10);
      var next = rows[i + 1] ? parseInt(rows[i + 1].getAttribute('data-min'), 10) : Infinity;
      rows[i].classList.toggle('is-active', qty >= min && qty < next);
    }
  }

  /* Etiqueta de rango: con tramo siguiente muestra "min - (sigMin-1)"; el ÚLTIMO queda abierto "min+".
     Solo presentación: los mínimos reales (data-min) y los % no se alteran. */
  function rangeLabel(min, nextMin, startAtOne) {
    if (!nextMin) return min + '+ pz';
    var hi = nextMin - 1;
    /* Q1 - la PRIMERA fila (la de precio publicado, pct null) se rotula desde 1:
       "1 - 12 pz" en vez de "12 pz", que es lo que salia cuando el minimo de la
       variante (metafield custom.minimum_quantity) coincide con el tope del tramo.
       Los demas tramos pasan startAtOne falso y conservan su min real intacto. */
    var lo = startAtOne ? 1 : min;
    return lo === hi ? lo + ' pz' : lo + ' - ' + hi + ' pz';
  }

  /* P3 - marca SOLO las filas cuyo contenido no cabe en el ancho del panel.
     Las que caben conservan su tamano; .is-tight las reduce via CSS. */
  function markTightTiers(box) {
    if (!box) return;
    /* El panel vive dentro de un <details> que arranca colapsado: mientras no
       este abierto no se renderiza y offsetWidth/scrollWidth valen 0, asi que
       medir ahi daria un resultado falso. Se sale y se vuelve a medir en el
       'toggle' de apertura (ver initCard). */
    if (!box.offsetWidth) return;
    var rows = box.querySelectorAll('.product-card-v2__vol-tier');

    /* R4 - quitar is-tight antes de medir para obtener el scrollWidth natural.
       Si se mide con is-tight ya aplicado (estado comprimido, gap 3px), la fila
       parece caber y la clase se elimina; en la segunda apertura queda
       desacomodada. Al cerrar el panel is-tight se queda puesta porque el guard
       de arriba retorna, asi que el reset es imprescindible. */
    for (var i = 0; i < rows.length; i++) {
      rows[i].classList.remove('is-tight');
    }
    void box.offsetWidth; /* reflow sincrono: scrollWidth refleja layout sin is-tight */

    /* M2 - medir y aplicar sobre la MISMA caja. Antes se comparaba el
       scrollWidth de la FILA contra el offsetWidth del CONTENEDOR: cajas
       distintas, con el padding de la fila y el del panel de por medio, asi
       que el veredicto salia descuadrado -- filas que cabian se marcaban y
       filas que no cabian se libraban. scrollWidth y clientWidth del MISMO
       elemento son la comparacion correcta. El margen de 0.5px evita falsos
       positivos por redondeo subpixel. */
    for (var i = 0; i < rows.length; i++) {
      if (rows[i].scrollWidth > rows[i].clientWidth + 0.5) {
        rows[i].classList.add('is-tight');
      }
    }
  }

  /* R3 - agenda una medicion coalescida: varias señales seguidas (resize +
     mutacion + apertura) colapsan en una sola medida tras layout y paint. */
  function scheduleTightMeasure(box) {
    if (!box) return;
    if (box.__tightMeasureRaf) {
      cancelAnimationFrame(box.__tightMeasureRaf);
    }
    box.__tightMeasureRaf = requestAnimationFrame(function () {
      box.__tightMeasureRaf = requestAnimationFrame(function () {
        box.__tightMeasureRaf = null;
        markTightTiers(box);
      });
    });
  }

  /* R2 -> R3 - observa el panel para re-medir is-tight: ResizeObserver cubre el
     cambio de ancho exterior y MutationObserver el cambio de contenido interno
     (filas que llegan tarde del fetch sin alterar el ancho del contenedor). */
  function observeTight(box) {
    if (!box || box.__tightObserved) return;
    box.__tightObserved = true;

    /* R3-patch - solo reaccionar a cambios de ANCHO. markTightTiers cambia el
       gap de las filas (4px -> 3px con is-tight), lo que altera la ALTURA del
       contenedor y volvia a disparar el observer: medir -> alto cambia ->
       medir... = parpadeo. Comparando el ancho redondeado se corta el bucle. */
    if ('ResizeObserver' in window) {
      box.__tightLastWidth = 0;
      box.__tightResizeObserver = new ResizeObserver(function (entries) {
        var newWidth = Math.round(entries[entries.length - 1].contentRect.width);
        if (newWidth === box.__tightLastWidth) return;
        box.__tightLastWidth = newWidth;
        scheduleTightMeasure(box);
      });
      box.__tightResizeObserver.observe(box);
    }

    if ('MutationObserver' in window) {
      box.__tightMutationObserver = new MutationObserver(function () {
        scheduleTightMeasure(box);
      });
      /* SIN attributes: markTightTiers escribe is-tight en classList y
         observar atributos crearia un bucle infinito de medicion. */
      box.__tightMutationObserver.observe(box, {
        childList: true,
        subtree: true,
        characterData: true
      });
    }
  }

  function renderTiers(card) {
    var st = getState(card);
    var vol = card.querySelector('[data-vol]');
    var box = card.querySelector('[data-vol-tiers]');
    var off = card.querySelector('[data-vol-off]');
    if (!vol || !box) return;

    if (!st.tiers.length) {
      vol.hidden = true;
      vol.open = false;
      refresh(card);
      return;
    }
    var v = st.variant;
    /* filas: base (precio publicado) + tramos reales del endpoint */
    var rows = [];
    if (v.min < st.tiers[0].min) {
      rows.push({ min: v.min, priceHtml: formatMoney(v.price, st.moneyFormat), pct: null });
    }
    var maxPct = 0;
    for (var i = 0; i < st.tiers.length; i++) {
      var t = st.tiers[i];
      if (t.percent > maxPct) maxPct = t.percent;
      rows.push({ min: t.min, priceHtml: formatMoney(tierUnitCents(v.price, t), st.moneyFormat), pct: t.percent });
    }
    var html = '';
    for (var j = 0; j < rows.length; j++) {
      var row = rows[j];
      var nextMin = rows[j + 1] ? rows[j + 1].min : null;
      html += '<div class="product-card-v2__vol-tier" data-min="' + row.min + '">' +
        '<span class="qty">' + rangeLabel(row.min, nextMin, j === 0 && row.pct === null) + '</span>' +
        '<span class="val"><b>' + row.priceHtml + '</b>' +
        (row.pct !== null
          ? '<span class="off">-' + (row.pct % 1 === 0 ? row.pct : row.pct.toFixed(1)) + '%</span>'
          : '') +
        '</span></div>';
    }
    box.innerHTML = html;
    /* R3 - si el panel se renderiza cerrado, los observers quedan conectados y
       la medicion real llega cuando la apertura le da tamano. */
    observeTight(box);
    scheduleTightMeasure(box);
    if (off) {
      off.textContent = '-' + (maxPct % 1 === 0 ? maxPct : maxPct.toFixed(1)) + '%';
      off.hidden = false;
    }
    vol.hidden = false;
    refresh(card);
  }

  function loadTiers(card) {
    var st = getState(card);
    if (!st || !st.variant || st.__tiersRequested === st.variant.id) return;
    st.__tiersRequested = st.variant.id;
    fetchTiers(card.dataset.productId, st.variant.id).then(function (tiers) {
      /* la variante pudo cambiar mientras respondía */
      if (getState(card).variant.id !== st.variant.id) return;
      getState(card).tiers = tiers;
      renderTiers(card);
    });
  }

  /* ---------------- cambio de variante (miniaturas) ---------------- */
  function switchVariant(card, variantId) {
    var st = getState(card);
    var v = null;
    for (var i = 0; i < st.variants.length; i++) {
      if (st.variants[i].id === variantId) { v = st.variants[i]; break; }
    }
    if (!v || !v.available) return;
    st.variant = v;
    st.tiers = [];
    st.basePriceText = null;
    card.dataset.variantId = String(v.id);

    /* claves de carrito: input oculto + select del tema */
    var hidden = card.querySelector('form [name="id"].product-variant-id');
    if (hidden) { hidden.value = v.id; hidden.disabled = false; }
    var select = card.querySelector('select[data-product-select]');
    if (select) select.value = String(v.id);

    /* selector de cantidad: min/step reales de la variante */
    var input = qtyInput(card);
    if (input) {
      input.setAttribute('data-min', v.min);
      input.min = v.min;
      input.step = v.step;
      input.value = v.min;
      input.setAttribute('data-quantity-variant-id', v.id);
      /* el quantity-input del tema revalida min/max y estados de los botones */
      input.dispatchEvent(new Event('change', { bubbles: true }));
    }

    /* SKU */
    var sku = card.querySelector('.product-card-v2__sku .text');
    if (sku && v.sku) sku.textContent = v.sku;

    /* stock (misma lógica que el server) */
    var stockText = card.querySelector('[data-stock-text]');
    if (stockText) {
      if (v.im === 'shopify' && v.inventory > 200) stockText.textContent = '+200 en stock';
      else stockText.textContent = 'En stock';
    }

    /* formato de venta -- CENSO-PLACEHOLDER-BADGE 2026-08-26: el badge "Por
       agregar" ya no vuelve a mostrarse nunca vía JS (no se toca fmtTodo).
       Sin dato se oculta la FILA completa (data-format), igual que el
       render inicial de Liquid -- así no queda la etiqueta "Formato de
       venta:" sola al cambiar a una variante sin metafields. Ver el
       comentario largo en snippets/card-product-v2.liquid. */
    var fmtRow = card.querySelector('[data-format]');
    var fmtReal = card.querySelector('[data-format-real]');
    var fmtQty = card.querySelector('[data-format-qty]');
    if (v.hasFormat) {
      var fq = v.step > 1 ? v.step : (v.min > 1 ? v.min : v.step);
      if (fmtQty) fmtQty.textContent = fq;
      var fmtUnit = card.querySelector('[data-format-unit]');
      if (fmtUnit) {
        var desktop = fmtUnit.querySelector('.fmt-unit-desktop');
        var mobile = fmtUnit.querySelector('.fmt-unit-mobile');
        if (desktop) desktop.textContent = fq === 1 ? 'pieza' : 'piezas';
        if (mobile) mobile.textContent = fq === 1 ? 'pza' : 'pzas';
      }
      if (fmtRow) fmtRow.hidden = false;
      if (fmtReal) fmtReal.hidden = false;
    } else {
      if (fmtRow) fmtRow.hidden = true;
    }

    /* ATC habilitado (solo variantes disponibles son seleccionables) */
    var atc = card.querySelector('.product-card-v2__atc');
    if (atc && atc.hasAttribute('disabled')) {
      atc.removeAttribute('disabled');
      var label = atc.querySelector('.product-card-v2__atc-text');
      if (label && atc.dataset.labelAdd) label.textContent = atc.dataset.labelAdd;
    }

    /* mayoreo de la nueva variante */
    var vol = card.querySelector('[data-vol]');
    if (vol) { vol.hidden = true; vol.open = false; }
    loadTiers(card);
    refresh(card);
  }

  /* ---------------- CARRUSEL-MINIATURAS (2026-08-19) ----------------
     El Liquid solo emite 4 botones; el resto de medios viaja comprimido en
     data-more-media y se materializa la PRIMERA vez que se pulsa una flecha.
     Asi la pagina no paga ni una peticion de imagen extra por adelantado. */
  /* Cuantas miniaturas EMITE el Liquid, no cuantas se ven: solo sirve para
     numerar el aria-label de las que se hidratan despues. Las visibles las
     decide el CSS (flex-basis), no el JS. */
  var V2_RENDERED_THUMBS = 4;

  function thumbGap(strip) {
    var g = parseFloat(getComputedStyle(strip).columnGap);
    return isFinite(g) ? g : 7;
  }

  /* limite = cuantas materializar como maximo. Sin limite, todas (es lo que hace
     la flecha). Las que no entran se devuelven al atributo, asi que el relleno
     puede hacerse por tandas sin perder nada. */
  function hydrateThumbs(strip, limite) {
    var raw = strip.getAttribute('data-more-media');
    if (!raw) return false;
    var extra;
    try { extra = JSON.parse(raw); } catch (e) { strip.removeAttribute('data-more-media'); return false; }
    if (!extra || !extra.length) { strip.removeAttribute('data-more-media'); return false; }

    var cuantas = (limite == null) ? extra.length : Math.min(limite, extra.length);
    if (cuantas <= 0) return false;
    var resto = extra.slice(cuantas);
    if (resto.length) strip.setAttribute('data-more-media', JSON.stringify(resto));
    else strip.removeAttribute('data-more-media');
    extra = extra.slice(0, cuantas);

    var card = strip.closest('[data-card-v2]');
    var titleEl = card && card.querySelector('.product-card-v2__title');
    var title = titleEl ? (titleEl.textContent || '').trim() : '';
    var frag = document.createDocumentFragment();
    /* el numero del aria-label sale de cuantas hay YA, no de una constante:
       con relleno por tandas el desfase se acumularia. */
    var yaHay = strip.querySelectorAll('.product-card-v2__thumb').length;

    for (var i = 0; i < extra.length; i++) {
      var url = extra[i][0];
      var vid = extra[i][1];
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'product-card-v2__thumb';
      b.setAttribute('data-thumb', '');
      if (vid) b.setAttribute('data-thumb-variant-id', String(vid));
      /* la url llega a width=96 (la de la miniatura); la grande se deriva
         reescribiendo ese mismo parametro, que lo pusimos nosotros. */
      b.setAttribute('data-image', url.replace(/([?&]width=)\d+/, '$1900'));
      b.setAttribute('aria-label', 'Ver imagen ' + (yaHay + i + 1) + (title ? ' de ' + title : ''));
      var img = document.createElement('img');
      img.src = url;
      img.loading = 'lazy';
      img.alt = '';
      b.appendChild(img);
      frag.appendChild(b);
    }
    strip.appendChild(frag);
    return true;
  }

  /* Cuantas miniaturas caben ENTERAS en el ancho actual de la tira. */
  function cuantasCaben(strip) {
    var t = strip.querySelector('.product-card-v2__thumb');
    if (!t) return 0;
    var w = t.getBoundingClientRect().width;
    if (!w) return 0;
    var g = thumbGap(strip);
    return Math.max(1, Math.floor((strip.clientWidth + g) / (w + g)));
  }

  /* RELLENO EN TIEMPO OCIOSO (2026-08-19)
     El Liquid sigue emitiendo 4 miniaturas: el primer pintado no cambia y la
     carga inicial no pide ni una imagen de mas, que es lo que protege el TBT.
     Cuando la pagina ya esta usable, se completan las que CABEN en ese ancho
     -- no todas: rellenar de mas volveria a pedir imagenes que nadie ve.
     No mueve el layout: las celdas se anaden en horizontal dentro de una tira
     con overflow hidden y alto fijado por el aspect-ratio de la celda. */
  function rellenarOcioso(strip) {
    if (!strip.hasAttribute('data-more-media')) return;
    var caben = cuantasCaben(strip);
    var hay = strip.querySelectorAll('.product-card-v2__thumb').length;
    var faltan = caben - hay;
    if (faltan <= 0) return;
    if (hydrateThumbs(strip, faltan)) updateArrows(strip);
  }

  var v2RellenoPedido = false;
  function programarRelleno() {
    if (v2RellenoPedido) return;
    v2RellenoPedido = true;
    var correr = function () {
      v2RellenoPedido = false;
      var tiras = document.querySelectorAll('.product-card-v2__thumbnails[data-more-media]');
      for (var i = 0; i < tiras.length; i++) rellenarOcioso(tiras[i]);
    };
    var ocioso = window.requestIdleCallback || function (cb) { return setTimeout(cb, 250); };
    var lanzar = function () { ocioso(correr, { timeout: 3000 }); };
    if (document.readyState === 'complete') lanzar();
    else window.addEventListener('load', lanzar, { once: true });
  }

  function setArrowOff(btn, off) {
    if (!btn) return;
    btn.disabled = !!off;
    btn.setAttribute('aria-disabled', off ? 'true' : 'false');
  }

  function activeIndex(strip) {
    var t = strip.querySelectorAll('.product-card-v2__thumb');
    for (var i = 0; i < t.length; i++) if (t[i].classList.contains('is-active')) return i;
    return -1;
  }

  /* Desplaza SOLO lo justo para que la miniatura quede a la vista. Si ya se ve
     entera, no mueve nada: la tira no salta por gusto. */
  function ensureVisible(strip, el) {
    var sr = strip.getBoundingClientRect();
    var er = el.getBoundingClientRect();
    var d = 0;
    if (er.left < sr.left) d = er.left - sr.left;
    else if (er.right > sr.right) d = er.right - sr.right;
    if (d) strip.scrollBy({ left: d, behavior: 'smooth' });
  }

  /* El estado de las flechas ya NO depende del scroll sino de CUAL esta activa:
     la flecha selecciona, no solo desplaza. */
  function updateArrows(strip) {
    var outer = strip.closest && strip.closest('.product-card-v2__thumbs-outer');
    if (!outer) return;
    var thumbs = strip.querySelectorAll('.product-card-v2__thumb');
    /* con carga pendiente hay mas fotos de las que hay botones, asi que
       "siguiente" sigue vivo aunque la activa sea la ultima renderizada. */
    var pendiente = strip.hasAttribute('data-more-media');
    var cur = activeIndex(strip);
    setArrowOff(outer.querySelector('[data-thumb-arrow="prev"]'), cur <= 0);
    setArrowOff(outer.querySelector('[data-thumb-arrow="next"]'), !pendiente && cur >= thumbs.length - 1);
  }

  function onThumbClick(card, thumb) {
    var thumbs = card.querySelectorAll('[data-thumb]');
    for (var i = 0; i < thumbs.length; i++) thumbs[i].classList.remove('is-active');
    thumb.classList.add('is-active');

    var img = card.querySelector('[data-main-image] img');
    var src = thumb.getAttribute('data-image');
    if (img && src) {
      img.removeAttribute('srcset');
      img.src = src;
    }
    var vid = parseInt(thumb.getAttribute('data-thumb-variant-id'), 10);
    if (isFinite(vid)) switchVariant(card, vid);

    /* pulsar una miniatura tambien mueve la activa, asi que las flechas de los
       extremos tienen que recalcularse igual que si hubiera sido una flecha. */
    var stripT = thumb.closest('.product-card-v2__thumbnails');
    if (stripT) updateArrows(stripT);
  }

  /* ---------------- copiar SKU + feedback (M1) ----------------
     El boton de copiar del SKU NO tenia ningun handler: el markup del snippet
     usa <div class="copy-text product-card-v2__sku"> pero NO el custom element
     is="copy-to-clipboard" de theme.js (CopyToClipboard), que es quien engancha
     el click y lee data-copy-value. Sin ese enganche no se copiaba nada ni se
     mostraba feedback. Aqui se implementa copia + feedback sin tocar el liquid. */
  function skuFeedback(btn) {
    /* Y2 - tooltip sobre el icono copiar: aparece encima del boton */
    var existing = document.querySelector('.sku-copied-toast');
    if (existing && existing.parentNode) {
      existing.parentNode.removeChild(existing);
    }
    var toast = document.createElement('span');
    toast.className = 'sku-copied-toast';
    toast.textContent = 'Copiado';
    document.body.appendChild(toast);
    if (btn && typeof btn.getBoundingClientRect === 'function') {
      var rect = btn.getBoundingClientRect();
      var th = toast.offsetHeight || 28;
      toast.style.left = Math.round(rect.left + rect.width / 2) + 'px';
      toast.style.top  = Math.max(6, Math.round(rect.top - th - 8)) + 'px';
    } else {
      toast.style.bottom = '90px';
      toast.style.left   = '50%';
    }
    setTimeout(function () {
      toast.classList.add('sku-copied-toast--out');
      setTimeout(function () {
        if (toast.parentNode) { toast.parentNode.removeChild(toast); }
      }, 350);
    }, 1700);
  }

  function legacyCopy(texto) {
    try {
      var ta = document.createElement('textarea');
      ta.value = texto;
      ta.setAttribute('readonly', '');
      ta.style.position = 'fixed';
      ta.style.top = '-1000px';
      document.body.appendChild(ta);
      ta.select();
      var ok = document.execCommand('copy');
      document.body.removeChild(ta);
      return ok;
    } catch (err) {
      return false;
    }
  }

  function copySku(sku, btn) {
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(sku).then(function () {
        skuFeedback(btn);
      })['catch'](function () {
        if (legacyCopy(sku)) skuFeedback(btn);
      });
      return;
    }
    if (legacyCopy(sku)) skuFeedback(btn);
  }

  /* ---------------- eventos delegados ---------------- */
  document.addEventListener('change', function (e) {
    var card = e.target.closest && e.target.closest('[data-card-v2]');
    if (!card) return;
    if (e.target.classList.contains('quantity__input')) refresh(card);
  });

  /* El scroll no burbujea, pero SI baja en fase de captura: un unico listener en
     document cubre todas las tiras, tambien las que llegan por AJAX. */
  document.addEventListener('scroll', function (e) {
    var t = e.target;
    if (t && t.classList && t.classList.contains('product-card-v2__thumbnails')) updateArrows(t);
  }, true);

  var v2ResizeTimer;
  window.addEventListener('resize', function () {
    clearTimeout(v2ResizeTimer);
    v2ResizeTimer = setTimeout(function () {
      var strips = document.querySelectorAll('.product-card-v2__thumbnails');
      for (var i = 0; i < strips.length; i++) updateArrows(strips[i]);
    }, 150);
  });

  document.addEventListener('click', function (e) {
    /* CARRUSEL-MINIATURAS - flechas. Va PRIMERO y corta la propagacion para que
       el clic no llegue ni a la tarjeta ni al cierre de desplegables de abajo.
       No navega y no recarga: es un <button type="button"> fuera del <a>. */
    var arrow = e.target.closest && e.target.closest('[data-thumb-arrow]');
    if (arrow) {
      e.preventDefault();
      e.stopPropagation();
      if (arrow.disabled) return;
      var outerA = arrow.closest('.product-card-v2__thumbs-outer');
      var strip = outerA && outerA.querySelector('.product-card-v2__thumbnails');
      if (!strip) return;
      /* LA FLECHA SELECCIONA, no solo desplaza. Hace EXACTAMENTE lo mismo que
         pulsar la miniatura de al lado -- un solo comportamiento, no dos: llama a
         onThumbClick, que marca la activa, cambia la foto grande y ejecuta
         switchVariant completo (precio, SKU, stock, formato de venta, min/step
         del selector y el name="id" oculto). Se hidrata ANTES de contar, para
         que la ultima renderizada no parezca el final cuando quedan mas. */
      hydrateThumbs(strip);
      var thumbs = strip.querySelectorAll('.product-card-v2__thumb');
      if (!thumbs.length) return;
      var dir = arrow.getAttribute('data-thumb-arrow') === 'next' ? 1 : -1;
      var cur = activeIndex(strip);
      if (cur < 0) cur = 0;
      var next = cur + dir;
      if (next < 0 || next >= thumbs.length) { updateArrows(strip); return; }
      var cardA = strip.closest('[data-card-v2]');
      if (cardA) onThumbClick(cardA, thumbs[next]);
      ensureVisible(strip, thumbs[next]);
      updateArrows(strip);
      return;
    }

    /* M1 - copia del SKU */
    var copyBtn = e.target.closest && e.target.closest('.product-card-v2__sku button');
    if (copyBtn) {
      e.preventDefault();
      var skuBox = copyBtn.closest('.product-card-v2__sku');
      var skuEl = skuBox && skuBox.querySelector('.text');
      var sku = skuEl ? (skuEl.textContent || '').trim() : '';
      if (sku) copySku(sku, copyBtn);
      return;
    }
    var thumb = e.target.closest && e.target.closest('[data-thumb]');
    if (thumb) {
      var card = thumb.closest('[data-card-v2]');
      if (card) onThumbClick(card, thumb);
      return;
    }
    /* cerrar desplegables de mayoreo al hacer clic fuera */
    var openVols = document.querySelectorAll('[data-card-v2] [data-vol][open]');
    for (var i = 0; i < openVols.length; i++) {
      if (!openVols[i].contains(e.target)) openVols[i].open = false;
    }
  });

  /* ---------------- arranque + carga perezosa ---------------- */
  var io = 'IntersectionObserver' in window
    ? new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            io.unobserve(entry.target);
            loadTiers(entry.target);
          }
        });
      }, { rootMargin: '200px 0px' })
    : null;

  function scan(root) {
    var cards = (root || document).querySelectorAll('[data-card-v2]:not([data-v2-ready])');
    for (var i = 0; i < cards.length; i++) {
      initCard(cards[i]);
      if (io) io.observe(cards[i]);
      else loadTiers(cards[i]);
    }
    /* tambien tras un repintado por AJAX: las tarjetas nuevas llegan con sus 4 */
    if (cards.length) programarRelleno();
  }

  /* al cambiar el ancho cabe otra cantidad; se recalcula sin prisa */
  var v2RellenoResize;
  window.addEventListener('resize', function () {
    clearTimeout(v2RellenoResize);
    v2RellenoResize = setTimeout(programarRelleno, 300);
  });

  function start() {
    scan(document);
    /* grids re-renderizados por AJAX (filtros / Section Rendering API) */
    var debounce;
    new MutationObserver(function () {
      clearTimeout(debounce);
      debounce = setTimeout(function () { scan(document); }, 250);
    }).observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();

  /* hook de QA (solo lectura, sin efectos) */
  window.__mahaCardV2 = { rangeLabel: rangeLabel };
})();
